import { useEffect, useState } from "react";
import { Quote, PenLine } from "lucide-react";
import { Link } from "react-router-dom";
import { IMG } from "../lib/images";
import { api } from "../lib/api";
import PageHeader from "../components/PageHeader";
import { Reveal } from "../components/motion";

const CATEGORIES = ["Jésus a changé ma vie", "Réponses à la prière", "Restauration", "Famille", "Espérance", "Guérison", "Parcours de foi"];

export default function Testimonials() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/testimonials").then(({ data }) => setItems(data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <>
      <PageHeader
        testid="testimonials-header"
        eyebrow="Témoignages"
        titleLines={["Des histoires vraies,", "des vies transformées"]}
        intro="Des témoignages authentiques de personnes de l'église : ce que Jésus a fait dans leur vie, raconté avec leurs mots."
        image={IMG.welcome}
      />
      <section className="py-16 sm:py-24">
        <div className="container-site">
          {loading && <p className="text-sm text-stone-500">Chargement…</p>}
          {!loading && !items.length && (
            <Reveal>
              <div data-testid="testimonials-empty" className="card-warm mx-auto max-w-2xl border-dashed p-12 text-center">
                <Quote className="mx-auto h-7 w-7 text-terracotta" />
                <p className="mt-5 font-serif text-2xl font-medium text-obsidian">Les premiers témoignages arrivent bientôt</p>
                <p className="mx-auto mt-4 max-w-md text-sm leading-relaxed text-stone-600">
                  Nous publierons ici les témoignages authentiques de personnes de La Maison de la
                  Charité : réponses à la prière, restauration, famille, espérance, guérison, parcours
                  de foi. Aucun témoignage inventé — seulement des histoires vraies.
                </p>
                <div className="mt-6 flex flex-wrap justify-center gap-2">
                  {CATEGORIES.map((c) => (
                    <span key={c} className="rounded-full bg-sand px-3 py-1 text-[11px] font-semibold text-stone-500">{c}</span>
                  ))}
                </div>
                <Link data-testid="testimonials-cta-contact" to="/contact" className="btn-outline mt-8">
                  <PenLine className="h-4 w-4" />
                  Partager mon témoignage
                </Link>
              </div>
            </Reveal>
          )}
          <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
            {items.map((t, i) => (
              <Reveal key={t.id} delay={(i % 3) * 0.08}>
                <blockquote data-testid={`testimonial-${t.id}`} className="card-warm flex h-full flex-col p-7">
                  <Quote className="h-6 w-6 text-terracotta" />
                  <p className="mt-4 flex-1 text-sm leading-relaxed text-stone-600">« {t.text} »</p>
                  <footer className="mt-6 border-t border-line pt-4">
                    <p className="font-serif text-base font-semibold text-obsidian">{t.name}</p>
                    <p className="mt-1 text-xs font-medium capitalize text-terracotta">{t.category}</p>
                  </footer>
                </blockquote>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
